<div class="actions-popover-setup">
  <button #trigger [matMenuTriggerFor]="actionsTasks" class="btn-actions">
    <i class="fa-solid fa-ellipsis"></i>
  </button>

  <!-- <mat-menu #actionsTasks="matMenu" class="mat-menu-actions-setup" xPosition="before" yPosition="auto"> -->
  <mat-menu #actionsTasks="matMenu" class="mat-menu-actions-setup" xPosition="before">
    <span class="buttons-list-actions-setup">
      <!-- View Details -->
      <button *ngIf="this.params?.actions?.viewDetail" class="btn-action" mat-menu-item (click)="viewDetailsByAction()">
        <i class="icon-details"></i> View Details
      </button>
      <!-- Stamp -->
      <button *ngIf="this.params?.actions?.stamp" class="btn-action" mat-menu-item (click)="viewDetailsByAction()">
        <i class="stamp-vendor"></i> Stamp
      </button>
      <!-- View Details Request-->
      <button
        *ngIf="this.params?.actions?.viewDetailRequest"
        class="btn-action"
        mat-menu-item
        (click)="viewDetailsByAction()"
      >
        <i class="icon-details"></i> View Detail Request
      </button>
      <!-- Update -->
      <button *ngIf="this.params?.actions?.update" class="btn-action" mat-menu-item (click)="viewDetailsByAction()">
        <i class="update-team"></i> Update
      </button>
      <!-- Inactivate -->
      <button *ngIf="this.params?.actions?.inactivate" class="btn-action" mat-menu-item (click)="viewDetailsByAction()">
        <i class="inactivate-block"></i> Inactivate
      </button>
    </span>
  </mat-menu>
</div>
